import { Stack } from '@mantine/core';

export function OnboardingLayoutSection({ children }: React.PropsWithChildren) {
    return <Stack>{children}</Stack>;
}
